var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpentabActive = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.75H2.25C1.69772 3.75 1.25 4.19772 1.25 4.75V17.75C1.25 18.3023 1.69772 18.75 2.25 18.75H15.25C15.8023 18.75 16.25 18.3023 16.25 17.75V15M7.5 15H17.75C18.3023 15 18.75 14.5523 18.75 14V2.25C18.75 1.69772 18.3023 1.25 17.75 1.25H6C5.44772 1.25 5 1.69772 5 2.25V12.5",
    stroke: "#0078A8",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.875L11.25 8.75L13.125 10.625L13.75 6.25L9.375 6.875Z",
    fill: "#0078A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.25L11.25 8.75M11.25 8.75L9.375 6.875L13.75 6.25L13.125 10.625L11.25 8.75Z",
    stroke: "#0078A8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpentabActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/opentab-active.54ee8c599d7775ad7426b7af17cd8816.svg";